<ng-container [formGroup]="nfeForm">
  <app-section
    title="Configurações da NF-e"
    description="Preencha os dados de emissão da NF-e"
  >
    <app-fields>
      <app-select
        label="Finalidade"
        [options]="finalidade"
        formControlName="finalidade"
      ></app-select>
      <app-select
        [options]="tipoImpressao"
        label="Tipo de impressão"
        formControlName="tipoImpressao"
      ></app-select>
      <app-select
        [options]="tipoEmissao"
        label="Tipo de emissão"
        formControlName="tipoEmissao"
      ></app-select>
      <app-select
        [options]="codigoIdentificadorDestino"
        label="Destino da operação"
        formControlName="codigoIdentificacaoDestino"
      ></app-select>
      <app-select
        [options]="natureza"
        label="Natureza da operação"
        formControlName="natureza"
      ></app-select>
      <app-select
        [options]="yesOrNot"
        formControlName="saida"
        label="Operação de saída"
      ></app-select>
      <app-select
        [options]="yesOrNot"
        formControlName="presencial"
        label="Operação presencial"
      ></app-select>
      <app-select
        [options]="yesOrNot"
        formControlName="consumidorFinal"
        label="Consumidor final"
      ></app-select>
      <ng-container *ngIf="!numeracaoAutomatica()">
        <app-select
          [options]="series()"
          formControlName="serie"
          label="Série"
          [editable]="true"
          (outputChange)="onSerieChange($event)"
        ></app-select>
        <div class="numero-field-container">
          <app-input formControlName="numero" label="Número" type="number">
            <small class="info" *ngIf="!!numeracao()?.numeracaoAtual"
              >Numeração atual [{{ numeracao()?.numeracaoAtual }}] para a série
              informada</small
            >
            <small class="warning-info">
              <i class="pi pi-exclamation-triangle"></i>
              A sua empresa não está configurada para emitir números
              automaticamente
            </small>
          </app-input>
        </div>
      </ng-container>
      <app-input
        label="Data de saída/entrada"
        formControlName="dataSaidaEntrada"
        mask="d0/M0/0000 Hh:m0"
      ></app-input>
    </app-fields>
    <app-fields *ngIf="isDevolucao()">
      <app-input
        label="Chave de acesso da NF-e original"
        formControlName="chaveNfeReferenciada"
        mask="0{44}"
        [maxlength]="44"
        placeholder="44 dígitos da chave da nota que está sendo devolvida"
        invalidMessage="Chave de acesso inválida (44 dígitos com dígito verificador válido)"
        hint="Obrigatória para NF-e de devolução: vai no grupo <NFref>/<refNFe> do XML"
      ></app-input>
    </app-fields>
    <app-fields>
      <app-input
        label="Informações complementares"
        formControlName="informacoesComplementares"
        type="textarea"
        placeholder="Utilizar | para quebra de linha"
      ></app-input>
    </app-fields>
  </app-section>
</ng-container>
